import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

const Account = ({
	priceCategory,
	accountType
}) => {

	return (
		<section className="argus-min-height" style={{padding: 70}}>
			<Card>
				<div className="argus-title-background mb-5">
					<div className="argus-title">Account Information</div>
				</div>

				<CardContent className="account_container">
					<article style={{marginBottom: 20}}>
						<Typography variant="h6" component="h2">Account Type :</Typography>
						<p className="account_sub_text">{accountType}</p>
					</article>
					<article>
						<Typography variant="h6" component="h2">Price Category:</Typography>
						<p className="account_sub_text">{priceCategory}</p>
					</article>

				</CardContent>
			</Card>
		</section>
	);
};
export default Account;
